import { merge } from '../helper';

import addBase64 from '../general/addBase64';

import isEmptyObject from '../general/isEmpty/isEmptyObject';
import setAttr from '../general/attr/setAttr';

import * as exElement from './element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): HTMLElement {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (img)
    const elImage = exElement.create({
        merge: defConfig,
        tag: 'img',
    });
    elements.element = elImage;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements.element;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using base64
    if (!isEmptyObject(config.base64)) {
        addBase64(elements.element, config.base64);
    }

    // If using src or url
    if (config.src != null || config.url != null) {
        const src = config.src || config.url;

        // If using file
        if (src instanceof File) {
            /*
             * TODO
             * File Reader
             */
            const reader = new FileReader();
            reader.onload = function (evt: ProgressEvent<FileReader>): any {
                /* setAttr(elements.element, 'src', evt.target.result); */
            };
            reader.readAsDataURL(src);
        }
        // If using string
        else if (typeof src === 'string') {
            setAttr(elements.element, 'src', src);
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
